module.exports = __webpack_public_path__ + "static/media/eulalia-animated-splash-screen.14ff3428.gif";